<style scoped lang="scss">
    .file-dropzone {
        border: none;
        text-align: center;
    }

    .vue-dropzone {
        background: #eee;
        border: thin dashed #666;
        padding: 0;
        margin: 0;
        min-height: inherit;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;

        .dropzone-custom-title {
            margin: 0;
        }
    }

    .file-type-select {
        display: flex;
        align-items: center;
        justify-content: space-around;
    }

    .file-type-select label {
        display: block;
        margin-right: 20px;
    }

    .file-wrapper {
        display: flex;
        align-items: center;
        /*justify-content: space-between;*/
        margin-bottom: 4px !important;
    }

    .a-file-search {
        font-size: 20px;
    }

    .uk-select,
    .number-input {
        min-height: 40px;
        margin-right: 10px;
    }

    .income-document {
        flex: 1 0 auto;
    }

    .sign-mark i {

    }

    .sign-mark span {

    }

    .td-divider {
        border-top: 1px solid #616161 !important;
    }
</style>

<template>
    <div class="uk-grid">
        <div class="uk-width-1-1">
            <legend>{{ __('tenant.inc_other_income_docs') }}</legend>
        </div>
        <div class="uk-width-1-1 uk-hidden-small">
            <p>
                {{ __('tenant.inc_other_for_each', {days: programSettings['required-days-of-income-proof']}) }}
            </p>

            <p>{{ __('tenant.inc_other_please_select') }}</p>
            <div class="uk-width-1-1">
                <div v-for="income in incomes">
                    <input type="checkbox" v-on:click="toggleIncomeType(income)" :checked="income.selected"/> {{
                    income.label }}
                </div>
            </div>

            <table class="uk-table uk-table-divider">
                <thead>
                <tr>
                    <th width="40%">{{ __('tenant.inc_other_income_type') }}</th>
                    <th width="15%">{{ __('tenant.inc_other_income_interval') }}</th>
                    <th width="45%">{{ __('tenant.inc_other_gross_income') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(income, idx) in incomes" class="td-divider">
                    <td v-if="income.selected == true">
                        <span>{{ income.label }}</span>

                        <template v-if="programSettings['requires-income-attestation']">

                            <div class="uk-margin-top file-type-select">
                                <label :for="`document-paystub_${idx}`"> <input
                                        :id="`member_${member.id}_document-paystub_${idx}`" type="radio" value="paystub"
                                        v-model="income.doc_type" @change="onChangeDocType(idx)"> &nbsp; {{
                                    getPaydocLabel(income) }}</label>
                                <label :for="`document-attestation_${idx}`"> <input
                                        :id="`member_${member.id}_document-attestation_${idx}`" type="radio"
                                        value="attestation" v-model="income.doc_type" @change="onChangeDocType(idx)">
                                    &nbsp; {{ __('tenant.inc_other_attestation') }}</label>
                            </div>
                        </template>
                    </td>
                    <td v-if="income.selected == true">
                        <div v-if="income.require_interval">
                            <validated-section :errors="errors" :field="`interval_${idx}`">
                                <select v-model="income.interval"
                                        @change="onIncomeIntervalChange(idx)"
                                        class="uk-select">
                                    <option :value="null">How often do you get paid?</option>
                                    <option v-for="(label, interval) in paymentIntervals" :value="interval">{{ label
                                        }}
                                    </option>
                                </select>
                            </validated-section>
                        </div>
                        <div v-else>{{ __('tenant.inc_other_last_days', {days: programSettings['required-days-of-income-proof'] }) }}</div>
                        <p v-if="income.require_interval && income.interval" v-html="__('tenant.inc_other_enter_gross_amount', {type: getPaystubCount(income) })"></p>
                    </td>
                    <td v-if="income.selected == true">
                        <template v-if="!income.require_interval || income.interval">
                            <div v-for="(item, index) in getIncomeAssets(income)">
                                <div class="uk-flex uk-margin-small-bottom">
                                    <vue-numeric
                                            currency="$"
                                            class="number-input"
                                            :class="{'uk-width-1-1': income.doc_type !== 'paystub' }"
                                            v-model="item.income_amount"
                                            @change.native="onInputChanged"
                                    ></vue-numeric>
                                    <div v-if="income.doc_type === 'paystub' && item.income_amount && item.income_amount > 0"
                                         class="income-document">
                                        <div v-if="item.document" class="uk-margin-bottom file-wrapper">
                                            <div class="uk-flex">
                                                <div class="icon-container">
                                                    <a href="javascript:;" :title="item.document.filename"
                                                       @click="previewFile(item.document)">
                                                        <i class="uk-icon-medium a-file-search"></i><br>
                                                        <span style="font-size: 0.8em;">{{ __('global.preview') }}</span>
                                                    </a>
                                                </div>

                                            </div>
                                            <a href="javascript:;" uk-tooltip title="Delete File"
                                               class="uk-margin-left uk-text-danger"
                                               @click="deleteDocument(idx, index, item.document, income.doc_type)"
                                               style="font-size: 20px;"><i class="fa fa-times"></i></a>
                                        </div>

                                        <template v-else>
                                            <validated-section :errors="errors"
                                                               :field="`document_${idx}_${income.doc_type}_${index}`">
                                                <div>
                                                    <vue-dropzone
                                                            :ref="`dropzoneUpload_${idx}_${income.doc_type}_${index}`"
                                                            :options="dropzoneOptions"
                                                            :useCustomSlot=true
                                                            v-on:vdropzone-sending="sendingFile"
                                                            v-on:vdropzone-success="onFileUpdated(idx, index, income)"
                                                            v-on:vdropzone-file-added="onFileAdded(income)"
                                                    >
                                                        <div class="dropzone-custom-content file-dropzone">
                                                            <p class="dropzone-custom-title">{{ __('tenant.inc_other_click_here_upload', {type: getPaydocLabel(income)}) }}</p>
                                                        </div>
                                                    </vue-dropzone>
                                                </div>
                                            </validated-section>
                                        </template>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <template v-if="!programSettings['uses-esign'] && income.doc_type !== 'paystub'">
                                    <div v-if="income.documents[0]" class="uk-margin-bottom file-wrapper">
                                        <div class="uk-flex">
                                            <div class="icon-container">
                                                <a href="javascript:;" @click="previewFile(income.documents[0])">
                                                    <i class="uk-icon-medium a-file-search"></i><br>
                                                    <span style="font-size: 0.8em;">{{ __('global.preview') }}</span>
                                                </a>
                                            </div>
                                            <a :href="`documents/download/${income.documents[0].id}`"
                                               target="_blank"><span class="uk-margin-left">{{income.documents[0].filename}}</span></a>
                                        </div>
                                        <a href="javascript:;" uk-tooltip title="Delete File"
                                           class="uk-margin-left uk-text-danger"
                                           @click="deleteDocument(idx, undefined, income.documents[0], income.doc_type)"
                                           style="font-size: 20px;"><i class="fa fa-times"></i></a>
                                    </div>
                                    <template v-else>
                                        <validated-section :errors="errors" :field="`document_${idx}_attestation`">
                                            <div>
                                                <vue-dropzone
                                                        :ref="`dropzoneUpload_${idx}_${income.doc_type}_${index}`"
                                                        :options="dropzoneOptions"
                                                        :useCustomSlot=true
                                                        v-on:vdropzone-sending="sendingFile"
                                                        v-on:vdropzone-success="onFileUpdated(idx, undefined, income)"
                                                        v-on:vdropzone-file-added="onFileAdded(income)"
                                                >
                                                    <div class="dropzone-custom-content file-dropzone">
                                                        <p class="dropzone-custom-title">{{ __('tenant.inc_other_click_here_upload_attestation') }}</p>
                                                    </div>
                                                </vue-dropzone>
                                            </div>
                                        </validated-section>
                                    </template>
                                </template>
                            </div>
                        </template>
                    </td>
                </tr>
                </tbody>
            </table>
            <div class="uk-text-center uk-margin-top" v-if="hasAttestationSelected">
                <template v-if="programSettings['uses-esign'] && hasAttestationSigned">
                    <div class="sign-mark">
                        <a href="javascript:;" class="uk-button uk-button-success" @click="onEsignButtonClick(idx)"><i
                                class="fa fa-check"></i> {{ __('tenant.inc_other_view_signed_form') }}</a>
                    </div>
                </template>
                <template v-else>
                    <validated-section :errors="errors" field="attestation_esign">
                        <a class="uk-button uk-button-primary" @click="onEsignButtonClick(idx)">{{ actionButtonLabel
                            }}</a></p>
                    </validated-section>
                </template>
            </div>
        </div>
        <div class="uk-width-small-1-1 uk-hidden-medium uk-hidden-large">
            <div class="uk-margin-bottom uk-width-1-1">
                <h5 v-html="__('tenant.inc_other_for_each_form', {days: programSettings['required-days-of-income-proof']})"></h5>
            </div>

            <div class="uk-width-1-1 uk-margin-large-bottom" v-for="(income, idx) in incomes">
                <div class="uk-margin-bottom">
                    <h4>
                        {{ income.label }}
                    </h4>
                    <template v-if="programSettings['requires-income-attestation']">
                        <div class="uk-margin-top file-type-select">
                            <label :for="`document-paystub_${idx}_mobile`"> <input
                                    :id="`member_${member.id}_document-paystub_${idx}_mobile`" type="radio"
                                    value="paystub" v-model="income.doc_type" @change="onChangeDocType(idx)"> &nbsp; {{
                                getPaydocLabel(income) }}</label>
                            <label :for="`document-attestation_${idx}_mobile`"> <input
                                    :id="`member_${member.id}_document-attestation_${idx}_mobile`" type="radio"
                                    value="attestation" v-model="income.doc_type" @change="onChangeDocType(idx)"> &nbsp;
                                {{ __('tenant.inc_other_attestation') }}</label>
                        </div>
                        <div class="uk-text-center" v-if="income.doc_type == 'attestation'">
                            <template v-if="programSettings['uses-esign'] && hasAttestationSigned">
                                <div class="sign-mark">
                                    <a href="javascript:;" class="uk-button uk-button-success"
                                       @click="onEsignButtonClick(idx)"><i class="fa fa-check"></i> {{ __('tenant.inc_other_view_signed_form') }}</a>
                                </div>
                            </template>
                            <template v-else>
                                <validated-section :errors="errors" field="attestation_esign">
                                    <a class="uk-button uk-button-primary" @click="onEsignButtonClick(idx)">{{
                                        actionButtonLabel }}</a></p>
                                </validated-section>
                            </template>
                        </div>
                    </template>
                </div>
                <div class="uk-margin-bottom">
                    <div v-if="income.require_interval">
                        <validated-section :errors="errors" :field="`interval_${idx}`">
                            <select v-model="income.interval"
                                    @change="onIncomeIntervalChange(idx)"
                                    class="uk-select uk-width-1-1">
                                <option :value="null">How often do you get paid?</option>
                                <option v-for="(label, interval) in paymentIntervals" :value="interval">{{ label }}
                                </option>
                            </select>
                        </validated-section>
                    </div>
                    <div v-else>Last {{ programSettings['required-days-of-income-proof'] }} Days</div>
                    <p v-if="income.doc_type === 'paystub' && income.require_interval && income.interval">Please enter the gross amount earned for the past <b>{{getPaystubCount(income)}}</b> pay period<span v-if="getPaystubCount(income) > 1">s</span>.</p>
                </div>
                <div class="uk-margin-bottom">
                    <template v-if="!income.require_interval || income.interval">
                        <div v-for="(item, index) in getIncomeAssets(income)">
                            <div class="uk-margin-small-bottom">
                                <vue-numeric currency="$" class="number-input uk-width-1-1" v-model="item.income_amount"
                                             @change.native="onInputChanged" type="text"></vue-numeric>
                                <div v-if="income.doc_type === 'paystub' && item.income_amount && item.income_amount > 0"
                                     class="income-document uk-width-1-1 uk-margin-small-top">
                                    <div v-if="item.document" class="uk-margin-bottom file-wrapper">
                                        <div class="uk-flex">
                                            <div class="icon-container">
                                                <a href="javascript:;" @click="previewFile(item.document)">
                                                    <i class="uk-icon-medium a-file-search"></i><br>
                                                    <span style="font-size: 0.8em;">{{ __('global.preview') }}</span>
                                                </a>
                                            </div>
                                        </div>
                                        <a href="javascript:;" uk-tooltip title="Delete File"
                                           class="uk-margin-left uk-text-danger"
                                           @click="deleteDocument(idx, index, item.document, income.doc_type)"
                                           style="font-size: 20px;"><i class="fa fa-times"></i></a>
                                    </div>

                                    <template v-else>
                                        <validated-section :errors="errors"
                                                            :field="`document_${idx}_${income.doc_type}_${index}`">
                                            <div>
                                                <vue-dropzone
                                                        :ref="`dropzoneUpload_${idx}_${income.doc_type}_${index}_mobile`"
                                                        :options="dropzoneOptions"
                                                        :useCustomSlot=true
                                                        v-on:vdropzone-sending="sendingFile"
                                                        v-on:vdropzone-success="onFileUpdated(idx, index, income, 'mobile')"
                                                        v-on:vdropzone-file-added="onFileAdded(income)"
                                                >
                                                    <div class="dropzone-custom-content file-dropzone">
                                                        <p class="dropzone-custom-title">{{ __('tenant.inc_other_click_here_upload', {type: 'abc'}) }}</p>
                                                    </div>
                                                </vue-dropzone>
                                            </div>
                                        </validated-section>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div>
                            <template v-if="!programSettings['uses-esign'] && income.doc_type !== 'paystub'">
                                <div v-if="income.documents[0]" class="uk-margin-bottom file-wrapper">
                                    <div class="uk-flex">
                                        <div class="icon-container">
                                            <a href="javascript:;" @click="previewFile(income.documents[0])">
                                                <i class="uk-icon-medium a-file-search"></i><br>
                                                <span style="font-size: 0.8em;">{{ __('global.preview') }}</span>
                                            </a>
                                        </div>
                                        <a :href="`documents/download/${income.documents[0].id}`"
                                            target="_blank"><span class="uk-margin-left">{{income.documents[0].filename}}</span></a>
                                    </div>
                                    <a href="javascript:;" uk-tooltip title="Delete File"
                                        class="uk-margin-left uk-text-danger"
                                        @click="deleteDocument(idx, undefined, income.documents[0], income.doc_type)"
                                        style="font-size: 20px;"><i class="fa fa-times"></i></a>
                                </div>
                                <template v-else>
                                    <validated-section :errors="errors" :field="`document_${idx}_attestation`">
                                        <div>
                                            <vue-dropzone
                                                    :ref="`dropzoneUpload_${idx}_${income.doc_type}_${index}_mobile`"
                                                    :options="dropzoneOptions"
                                                    :useCustomSlot=true
                                                    v-on:vdropzone-sending="sendingFile"
                                                    v-on:vdropzone-success="onFileUpdated(idx, undefined, income, 'mobile')"
                                                    v-on:vdropzone-file-added="onFileAdded(income)"
                                            >
                                                <div class="dropzone-custom-content file-dropzone">
                                                    <p class="dropzone-custom-title">{{ __('tenant.inc_other_click_here_upload_attestation') }}</p>
                                                </div>
                                            </vue-dropzone>
                                        </div>
                                    </validated-section>
                                </template>
                            </template>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div class="uk-width-1-1 uk-text-right">
            <validated-section :errors="errors" field="total_requested">
            </validated-section>
        </div>
        <preview-document-modal ref="previewModal"></preview-document-modal>
        <modal-dialog
                title="Applicant Esign Form"
                ref="confirmIncomeModal"
                @close="onCloseModalConfirm"
                @confirm="onCompleteModalConfirm"
                :isFullScreen="true"
                :showCancelButton="false"
                :showOkButton="false"
        >
            <NoIncomeForm
                    :members="members"
                    :member="member"
                    :incomes="incomes"
                    :incomeIndex="selectIndex"
                    :label="label"
                    :url="url"
                    :ref="`noIncomeForm_${member.id}`"
                    @onSubmitForm="onSubmitForm"
                    @onCancelForm="onCancelForm"
            >
            </NoIncomeForm>
        </modal-dialog>

        <modal-dialog
                title="Confirmation"
                ref="confirmIncomeChangeModal"
                @confirm="onCompleteIncomeChangeModal"
                confirmText="Ok"
                :showCancelButton="false"
                :stuck="true"
        >
            <p>{{ __('tenant.inc_other_your_edit') }}</p>
        </modal-dialog>
    </div>
</template>

<script>
    import {mapGetters, mapState} from 'vuex';
    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import ValidatedSection from "../../../../../../components/Common/ValidatedSection";
    import PreviewDocumentModal from "../../../../../../../dashboard/pages/Documents/PreviewDocumentModal";
    import DocRequest from "./DocRequest";
    import NoIncomeForm from "./NoIncomeForm";
    import ModalDialog from "../../../../../../components/Common/ModalDialog";

    export default {
        name: "IncomeEntryFormV4",
        components: {
            vueDropzone: vue2Dropzone,
            ValidatedSection,
            PreviewDocumentModal,
            NoIncomeForm,
            ModalDialog,
            DocRequest
        },
        props: ['label', 'member', 'members', 'values', 'url'],
        data() {
            return {
                attestationSigned: false,
                errors: {},
                selectIndex: null,
                signatureData: {},
                paymentIntervals: {
                    monthly: this.__('tenant.inc_other_int_monthly'),
                    weekly: this.__('tenant.inc_other_int_weekly'),
                    biweekly: this.__('tenant.inc_other_int_biweekly'),
                    bimonthly: this.__('tenant.inc_other_int_bimonthly'),
                    annually: this.__('tenant.inc_other_int_annually'),
                    other: this.__('tenant.inc_other_int_other')
                },

                paymentIntervalValues: {
                    monthly: 'Month',
                    weekly: 'Week',
                    biweekly: 'Week',
                    bimonthly: 'Month',
                    annually: 'Year',
                    other: 'Other'
                },

                paymentConstants: {
                    monthly: 1,
                    weekly: 2,
                    biweekly: 3,
                    bimonthly: 4,
                    annually: 5,
                    other: 1
                },
                incomeTypes: [
                    {
                        id: 'primary_monthly',
                        label: this.__('tenant.inc_other_type_primary_monthly'),
                    },
                    {
                        id: 'secondary_monthly',
                        label: this.__('tenant.inc_other_type_secondary_monthly'),
                    },
                    {
                        id: 'tertiary_monthly',
                        label: this.__('tenant.inc_other_type_tertiary_monthly'),
                    },
                    {
                        id: 'self_employment_monthly',
                        label: this.__('tenant.inc_other_type_self_employment_monthly'),
                    },
                    {
                        id: 'service_pay',
                        label: this.__('tenant.inc_other_type_service_pay'),
                    },
                    {
                        id: 'operation_business',
                        label: this.__('tenant.inc_other_operation_business'),
                    },
                    {
                        id: 'sales_consulting',
                        label: this.__('tenant.inc_other_sales_consulting'),
                    },
                    {
                        id: 'worker-compensation',
                        label: this.__('tenant.inc_other_type_worker-compensation'),
                    },
                    {
                        id: 'interest',
                        label: this.__('tenant.inc_other_type_interest'),
                    },
                    {
                        id: 'unemployment-benefit',
                        label: this.__('tenant.inc_other_type_unemployment-benefit'),
                    },
                    {
                        id: 'ssi',
                        label: this.__('tenant.inc_other_type_ssi'),
                    },
                    {
                        id: 'annuities',
                        label: this.__('tenant.inc_other_type_annuities'),
                    },
                    {
                        id: 'insurance',
                        label: this.__('tenant.inc_other_type_insurance'),
                    },
                    {
                        id: 'alimony',
                        label: this.__('tenant.inc_other_type_alimony'),
                    },
                    {
                        id: 'regular_contribution',
                        label: this.__('tenant.inc_other_type_regular_contribution'),
                    },
                    {
                        id: 'tanf',
                        label: this.__('tenant.inc_other_type_tanf'),
                    },
                    {
                        id: 'all_regular_pay',
                        label: this.__('tenant.inc_other_type_all_regular_pay'),
                    },
                ],
                incomes: [
                    {
                        id: null,
                        type: 'primary_monthly',
                        label: this.__('tenant.inc_other_type_primary_monthly'),
                        require_interval: true,
                        interval: null,
                        income_amount: 0,
                        doc_type: 'paystub',
                        documents: [],
                        paystubs: [],
                        attestations: [],
                        additional_info: {},
                        selected: true
                    },
                    {
                        id: null,
                        type: 'secondary_monthly',
                        label: this.__('tenant.inc_other_type_secondary_monthly'),
                        require_interval: true,
                        interval: null,
                        income_amount: 0,
                        doc_type: 'paystub',
                        documents: [],
                        paystubs: [],
                        attestations: [],
                        additional_info: {},
                        selected: false
                    },
                    {
                        id: null,
                        type: 'tertiary_monthly',
                        label: this.__('tenant.inc_other_type_tertiary_monthly'),
                        require_interval: true,
                        interval: null,
                        income_amount: 0,
                        doc_type: 'paystub',
                        documents: [],
                        paystubs: [],
                        attestations: [],
                        additional_info: {},
                        selected: false
                    },
                    {
                        id: null,
                        type: 'self_employment_monthly',
                        label: this.__('tenant.inc_other_type_self_employment_monthly'),
                        require_interval: false,
                        interval: null,
                        income_amount: 0,
                        doc_type: 'paystub',
                        documents: [],
                        paystubs: [],
                        attestations: [],
                        additional_info: {},
                        selected: false
                    },
                    {
                        id: null,
                        type: 'service_pay',
                        label: this.__('tenant.inc_other_type_service_pay'),
                        require_interval: false,
                        interval: null,
                        income_amount: 0,
                        doc_type: 'paystub',
                        documents: [],
                        paystubs: [],
                        attestations: [],
                        additional_info: {},
                        selected: false
                    },
                    {
                        id: null,
                        type: 'operation_business',
                        label: this.__('tenant.inc_other_operation_business'),
                        require_interval: false,
                        interval: null,
                        income_amount: 0,
                        doc_type: 'paystub',
                        documents: [],
                        paystubs: [],
                        attestations: [],
                        additional_info: {},
                        selected: false
                    },
                    {
                        id: null,
                        type: 'sales_consulting',
                        label: this.__('tenant.inc_other_sales_consulting'),
                        require_interval: false,
                        interval: null,
                        income_amount: 0,
                        doc_type: 'paystub',
                        documents: [],
                        paystubs: [],
                        attestations: [],
                        additional_info: {},
                        selected: false
                    },
                    {
                        id: null,
                        type: 'worker-compensation',
                        label: this.__('tenant.inc_other_type_worker-compensation'),
                        require_interval: false,
                        interval: null,
                        income_amount: 0,
                        doc_type: 'paystub',
                        documents: [],
                        paystubs: [],
                        attestations: [],
                        additional_info: {},
                        selected: false
                    },
                    {
                        id: null,
                        type: 'interest',
                        label: this.__('tenant.inc_other_type_interest'),
                        require_interval: false,
                        interval: null,
                        income_amount: 0,
                        doc_type: 'paystub',
                        documents: [],
                        paystubs: [],
                        attestations: [],
                        additional_info: {},
                        selected: false
                    },
                    {
                        id: null,
                        type: 'unemployment-benefit',
                        label: this.__('tenant.inc_other_type_unemployment-benefit'),
                        require_interval: false,
                        interval: null,
                        income_amount: 0,
                        doc_type: 'paystub',
                        documents: [],
                        paystubs: [],
                        attestations: [],
                        additional_info: {},
                        selected: false
                    },
                    {
                        id: null,
                        type: 'ssi',
                        label: this.__('tenant.inc_other_type_ssi'),
                        require_interval: false,
                        interval: null,
                        income_amount: 0,
                        doc_type: 'paystub',
                        documents: [],
                        paystubs: [],
                        attestations: [],
                        additional_info: {},
                        selected: false
                    },
                    {
                        id: null,
                        type: 'annuities',
                        label: this.__('tenant.inc_other_type_annuities'),
                        require_interval: false,
                        interval: null,
                        income_amount: 0,
                        doc_type: 'paystub',
                        documents: [],
                        paystubs: [],
                        attestations: [],
                        additional_info: {},
                        selected: false
                    },
                    {
                        id: null,
                        type: 'insurance',
                        label: this.__('tenant.inc_other_type_insurance'),
                        require_interval: false,
                        interval: null,
                        income_amount: 0,
                        doc_type: 'paystub',
                        documents: [],
                        paystubs: [],
                        attestations: [],
                        additional_info: {},
                        selected: false
                    },
                    {
                        id: null,
                        type: 'alimony',
                        label: this.__('tenant.inc_other_type_alimony'),
                        require_interval: false,
                        interval: null,
                        income_amount: 0,
                        doc_type: 'paystub',
                        documents: [],
                        paystubs: [],
                        attestations: [],
                        additional_info: {},
                        selected: false
                    },
                    {
                        id: null,
                        type: 'regular_contribution',
                        label: this.__('tenant.inc_other_type_regular_contribution'),
                        require_interval: false,
                        interval: null,
                        income_amount: 0,
                        doc_type: 'paystub',
                        documents: [],
                        paystubs: [],
                        attestations: [],
                        additional_info: {},
                        selected: false
                    },
                    {
                        id: null,
                        type: 'tanf',
                        label: this.__('tenant.inc_other_type_tanf'),
                        require_interval: false,
                        interval: null,
                        income_amount: 0,
                        doc_type: 'paystub',
                        documents: [],
                        paystubs: [],
                        attestations: [],
                        additional_info: {},
                        selected: false
                    },
                    {
                        id: null,
                        type: 'all_regular_pay',
                        label: this.__('tenant.inc_other_type_all_regular_pay'),
                        require_interval: false,
                        interval: null,
                        income_amount: 0,
                        doc_type: 'paystub',
                        documents: [],
                        paystubs: [],
                        attestations: [],
                        additional_info: {},
                        selected: false
                    },
                ],
                dropzoneOptions: {
                    url: this.url,
                    thumbnailWidth: 200,
                    addRemoveLinks: true,
                    previewTemplate: "<div></div>"
                },
                sendingFileType: null,
                sendingDocType: null,
                paystubTemplate: {
                    id: null,
                    income_amount: undefined,
                    document: undefined,
                }
            }
        },
        computed: {
            ...mapState('Application', {
                application: 'application',
            }),
            ...mapGetters('Application', ['programSettings']),

            actionButtonLabel() {
                return this.programSettings['uses-esign'] ? 'Esign Attestation Form' : 'Download Attestation'
            },

            hasAttestationSelected() {
                return this.incomes.findIndex(item => item.doc_type == 'attestation') !== -1
            },

            hasAttestationEsign() {
                let result = false
                _.each(this.incomes, (item) => {
                    if (item.doc_type == 'attestation')
                        result = true
                })
                return result
            },

            hasAttestationSigned() {
                return !!this.member.signatures.find(item => item.key === `no-income`) || this.attestationSigned
            },
        },
        mounted() {
            const incomeTypeIds = this.incomeTypes.map(item => item.id)

            const filteredIncomes = this.member.incomes.filter(item => incomeTypeIds.includes(item.type))
            _.each(this.incomes, (item, idx) => {
                item = _.extend(item, filteredIncomes.find(o => o.type === item.type))
                item.additional_info = item.additional_info || {}
                item.selected = !!this.getAnnualIncomeFromIncomeValue(item)
                this.initIncomeAssets(idx)
            });

        },
        methods: {
            isMobile() {
                if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    return true
                } else {
                    return false
                }
            },

            getAnnualIncomeFromIncomeValue(income) {
                let amount = income.income_amount
                let arr = ['paystub', 'attestation']
                if (arr.includes(income.doc_type)) {
                    let incomeAssets = income.doc_type === 'paystub' ? income.paystubs : income.attestations
                    amount = _.reduce(incomeAssets, (sum, item) => {
                        return sum + item.income_amount
                    }, 0);
                    amount = incomeAssets.length ? amount / incomeAssets.length : 0;
                    switch (income.interval) {
                        case 'monthly':
                        case 'other':
                            amount = parseFloat(amount) * 12;
                            break;

                        case 'weekly':
                            amount = parseFloat(amount) * 52;
                            break;

                        case 'biweekly':
                            amount = parseFloat(amount) * 26;
                            break;

                        case 'bimonthly':
                            amount = parseFloat(amount) * 24;
                            break;

                        case 'annually':
                            amount = parseFloat(amount);
                            break;

                        default:
                            amount = parseFloat(amount) * 12;
                            break;
                    }
                }

                return amount ? amount : 0;

            },

            getIncomeAssets(income) {
                let result = []

                if (income.doc_type === 'paystub') {
                    result = income.paystubs
                } else {
                    result = income.attestations
                }
                return result
            },

            getAmountPlaceHolder(index, income) {
                if (income.interval)
                    return `${this.paymentIntervalValues[income.interval]} ${index + 1}` + income.doc_type
                else
                    return `Gross Income ${index + 1}` + income.doc_type
            },

            onCompleteIncomeChangeModal() {

            },

            onCancelForm() {
                this.$refs.confirmIncomeModal.close()
            },

            onSubmitForm(data) {
                this.errors = {}
                const {signature, incomesData, closeModal} = data
                this.signatureData = signature
                this.attestationSigned = true

                _.each(this.incomes, (item, idx) => {
                    if (item.require_interval) {
                        item.additional_info = {
                            ...incomesData[idx].additional_info
                        }
                    }
                });

                closeModal && this.onCancelForm();

                this.onInputChanged(false)
            },

            onEsignButtonClick(idx) {
                this.selectIndex = idx
                this.$refs.confirmIncomeModal.open()
            },

            onCloseModalConfirm() {

            },

            onCompleteModalConfirm() {

            },

            getPaydocLabel(income) {
                return income.require_interval ? 'Document' : 'Payment Doc'
            },

            onChangeDocType(idx) {
                this.initIncomeAssets(idx)
                this.onInputChanged(false)
            },

            onIncomeIntervalChange(idx) {
                this.initIncomeAssets(idx);
                let showModal = false
                if (this.incomes[idx].doc_type === 'attestation' && this.hasAttestationSigned) {
                    showModal = true
                }
                this.onInputChanged(showModal)
            },

            initIncomeAssets(idx) {
                if (this.incomes[idx]) {
                    let income = this.incomes[idx]
                    if (income.require_interval && income.interval == null) {
                        income[`${income.doc_type}s`] = []
                    } else {
                        let assetLimit = this.getPaystubCount(income)
                        let arr = [
                            'paystubs',
                            'attestations'
                        ]
                        _.each(arr, (type) => {
                            if (income && income[type]) {
                                let assetCount = income[type].length
                                if (assetCount < assetLimit) {
                                    for (let i = 0; i < assetLimit - assetCount; i++) {
                                        income[type].push({
                                            id: null,
                                            income_amount: undefined,
                                            document: undefined,
                                        })
                                    }
                                } else if (assetCount > assetLimit) {
                                    income[type].splice(assetLimit, assetCount - assetLimit)
                                }
                            }
                        })
                    }
                }
            },

            previewFile(document) {
                let url = `/api/hope/documents/${document.id}/preview`;
                this.$refs.previewModal.open(url, document);
            },

            onFileAdded(income) {
                this.sendingFileType = income.type
                this.sendingDocType = income.doc_type
            },

            getPaystubCount(income) {
                let cnt = 0;
                switch (income.interval) {
                    case 'weekly':
                        cnt = 4
                        break;
                    case 'biweekly':
                        cnt = 3
                        break;
                    case 'bimonthly':
                        cnt = 2
                        break;
                    case 'monthly':
                    case 'annually':
                    case 'other':
                        cnt = 1;
                        break;
                    default:
                        cnt = 1;
                        break;
                }
                if (income.interval !== 'annually')
                    cnt = cnt * this.programSettings['required-days-of-income-proof'] / 30
                return cnt
            },

            sendingFile(file, xhr, formData) {
                formData.append('application_id', this.application.id);
                formData.append('household_member_id', this.member.id);
                formData.append('type', this.sendingFileType);
                formData.append('doc_type', this.sendingDocType);
            },

            _getDocumentIdsFromOrgFiles(files) {
                if (files && files.length) {
                    const res = JSON.parse(files[0].xhr.response);
                    return [res.document]
                }
                return []
            },

            getDocuments(index, assetIndex, income, type) {
                let refIndex = `dropzoneUpload_${index}_${income.doc_type}`
                if (assetIndex != undefined)
                    refIndex += `_${assetIndex}`
                if (type)
                    refIndex = refIndex + '_' + type

                let ref = this.$refs[refIndex][0];
                const orgFiles = ref.getAcceptedFiles()
                ref.removeAllFiles();
                return this._getDocumentIdsFromOrgFiles(orgFiles);
            },

            onFileUpdated(index, assetIndex, income, type = undefined) {
                const newDocs = this.getDocuments(index, assetIndex, income, type);
                if (newDocs && newDocs.length) {
                    if (income.doc_type === 'paystub') {
                        this.incomes[index].paystubs[assetIndex].document = newDocs[0];
                    } else {
                        this.incomes[index].documents.push(newDocs[0]);
                    }
                }
            },

            deleteDocument(index, docIndex, doc, doc_type) {
                this.$store
                    .dispatch('Document/deleteDocument', doc.id)
                    .then((res) => {
                        if (doc_type === 'paystub')
                            this.incomes[index].paystubs[docIndex].document = null
                        else
                            this.incomes[index].documents = []
                    })
                    .catch((err) => {
                    })
            },

            toggleIncomeType: function (obj) {
                obj.selected = obj.selected ? false : true;
            },

            validate() {
                this.errors = {};
                let isValid = true;

                if (this.programSettings['uses-esign'] && this.hasAttestationEsign && this.$refs[`noIncomeForm_${this.member.id}`]) {
                    isValid = this.$refs[`noIncomeForm_${this.member.id}`].validate();

                    if (!isValid) {
                        this.errors['attestation_esign'] = {errors: ["You must esign attestation form."]}
                    }
                }
                _.each(this.incomes, (income, index) => {
                    if (income.doc_type === 'paystub') {
                        _.each(income.paystubs, (item, index1) => {
                            if (item.income_amount && item.income_amount > 0 && !item.document) {
                                this.errors[`document_${index}_paystub_${index1}`] = {errors: ["You must provide a document."]}
                            }
                        });
                    } else if (!this.programSettings['uses-esign']) {
                        if (income.documents && !income.documents.length) {
                            this.errors[`document_${index}_attestation`] = {errors: ["You must provide a document."]}
                        }
                    }
                })

                let total = 0;
                _.each(this.incomes, income => {
                    total += this.getAnnualIncomeFromIncomeValue(income)
                })

                if (total === 0) {
                    this.errors['total_requested'] = {errors: ["You must provide at least one income amount."]}
                }

                let errorCount = _.size(this.errors);

                if (errorCount > 0) isValid = false;

                return isValid;
            },

            onInputChanged(showConfirm = true) {
                if (showConfirm && this.hasAttestationSigned && this.programSettings['uses-esign']) {
                    this.$store.dispatch('Application/resetMemberSignature', {id: this.member.id, key: 'no-income'})
                        .then(() => {
                            this.$refs[`noIncomeForm_${this.member.id}`].$refs['signatureBox'].reset()
                            this.attestationSigned = false
                            this.updateIncomeData()
                            this.$refs.confirmIncomeChangeModal.open();
                        })
                        .catch((error) => {
                            this.$refs.confirmIncomeChangeModal.open();
                        })
                } else {
                    this.updateIncomeData()
                }
            },

            updateIncomeData() {
                _.each(this.incomes, (income, index) => {
                    if (income.require_interval && income.interval) {
                        if (this.errors[`interval_${index}`])
                            delete this.errors[`interval_${index}`]
                    }
                })

                this.$emit('updated', {
                    member: this.member,
                    amounts: this.incomes,
                    signatureData: this.signatureData
                });
            }
        }
    }
</script>
